import { render } from "./SubMenu.vue?vue&type=template&id=426a4c65"
import script from "./SubMenu.vue?vue&type=script&lang=js"
export * from "./SubMenu.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__